module.exports = __webpack_public_path__ + "static/svg_waves-3c1f0a785319462f6dce04d227eaf664.jpg";